import styled from 'styled-components';

const RootWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
`;

export default RootWrapper;
